<template>
    <div>
        <v-card v-show="show">
            <v-toolbar color="primary" dark>
                <v-toolbar-title>{{$t(formName)}}</v-toolbar-title>
            </v-toolbar>
            <v-form id="createForm">
                <div id="canvas" style="height: 300px;background-color: cornflowerblue; border:none"></div>
                <div id="taskDetail">
                    <v-tabs color="cyan" dark slider-color="yellow" v-model="tabs"
                            v-if="formProperties['tabs'] != null && formProperties['tabs'].length >0">
                        <v-tab v-for="tab in formProperties['tabs']" :key="tab.key">
                            {{ tab.name }}
                        </v-tab>
                        <v-tabs-items style="padding:10px">
                            <v-tab-item v-for="tab in formProperties['tabs']" :key="tab.key">
                                <div v-for="item in lstModel">
                                    <div v-if="item.properties['container'] == tab.name">
                                        <v-text-field v-if="item.type=='Textbox'"
                                                      v-model="startValue[item.properties['name']]" readonly
                                                      v-bind="item.properties"></v-text-field>
                                        <i-datepicker v-if="item.type=='DateField'"
                                                      v-model="startValue[item.properties['name']]"
                                                      readonly v-bind="item.properties"/>
                                        <v-textarea v-if="item.type=='Textarea'"
                                                    v-model="startValue[item.properties['name']]" readonly
                                                    v-bind="item.properties"></v-textarea>
                                        <i-selectbox v-if="item.type=='SelectBox'"
                                                     v-model="startValue[item.properties['name']]" readonly
                                                     v-bind="item.properties" :variable="startValue"></i-selectbox>
                                        <v-radio-group v-if="item.type=='Radio'"
                                                       v-model="startValue[item.properties['name']]" readonly
                                                       v-bind="item.properties">
                                            <v-radio v-for="option in item.properties['items']" :label="option"
                                                     :value="option"
                                                     :key="option"></v-radio>
                                        </v-radio-group>
                                        <v-checkbox v-if="item.type=='Checkbox'"
                                                    v-model="startValue[item.properties['name']]" readonly
                                                    v-bind="item.properties"></v-checkbox>
                                        <i-upload v-if="item.type=='Upload'"
                                                  v-model="startValue[item.properties['name']]" readonly
                                                  v-bind="item.properties" ref="input"></i-upload>
                                        <i-data-table v-if="item.type=='DataTable'"
                                                      v-model="startValue[item.properties['name']]"
                                                      :variable="startValue" readonly
                                                      v-bind="item.properties"></i-data-table>
                                        <i-entity-table v-if="item.type=='Entity'"
                                                        v-model="startValue[item.properties['name']]"
                                                        :variable="startValue"
                                                        v-bind="item.properties"></i-entity-table>
                                        <component v-if="item.type=='Component'"
                                                   v-model="startValue[item.properties['name']]"
                                                   :variable="startValue" :is="item.component"
                                                   v-bind="item.properties"></component>
                                    </div>
                                </div>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-tabs>
                    <div v-else style="padding: 10px">
                        <div v-for="item in lstModel">
                            <v-text-field v-if="item.type=='Textbox'" v-model="startValue[item.properties['name']]"
                                          readonly
                                          v-bind="item.properties"></v-text-field>
                            <i-datepicker v-if="item.type=='DateField'" v-model="startValue[item.properties['name']]"
                                          readonly v-bind="item.properties"/>
                            <v-textarea v-if="item.type=='Textarea'" v-model="startValue[item.properties['name']]"
                                        readonly
                                        v-bind="item.properties"></v-textarea>
                            <i-selectbox v-if="item.type=='SelectBox'" v-model="startValue[item.properties['name']]"
                                         readonly
                                         v-bind="item.properties" :variable="startValue"></i-selectbox>
                            <v-radio-group v-if="item.type=='Radio'" v-model="startValue[item.properties['name']]"
                                           readonly
                                           v-bind="item.properties">
                                <v-radio v-for="option in item.properties['items']" :label="option" :value="option"
                                         :key="option"></v-radio>
                            </v-radio-group>
                            <v-checkbox v-if="item.type=='Checkbox'" v-model="startValue[item.properties['name']]"
                                        readonly
                                        v-bind="item.properties"></v-checkbox>
                            <i-upload v-if="item.type=='Upload'" v-model="startValue[item.properties['name']]" readonly
                                      v-bind="item.properties" ref="input"></i-upload>
                            <i-data-table v-if="item.type=='DataTable'" v-model="startValue[item.properties['name']]"
                                          :variable="startValue" readonly
                                          v-bind="item.properties"></i-data-table>
                            <i-entity-table v-if="item.type=='Entity'" v-model="startValue[item.properties['name']]"
                                            :variable="startValue"
                                            v-bind="item.properties"></i-entity-table>
                            <component v-if="item.type=='Component'"
                                       v-model="startValue[item.properties['name']]"
                                       :variable="startValue" :is="item.component"
                                       v-bind="item.properties"></component>
                        </div>
                        <component :is="formComponent" v-on:mounted="formViewLoad" ref="formView"></component>
                    </div>

                </div>
            </v-form>
            <div style="text-align: right">
                <v-btn color="primary" @click="onProcess" v-if="readonly==false">
                    <v-icon dark left>build</v-icon>
                    {{$t('lang.common.process')}}
                </v-btn>
                <v-btn color="purple" dark @click="onShowHistory(true)">
                    <v-icon dark left>list</v-icon>
                    {{$t('lang.common.history')}}
                </v-btn>
                <v-btn color="error" @click="onCancel">
                    <v-icon dark left>cancel</v-icon>
                    {{$t('lang.common.cancel')}}
                </v-btn>
            </div>
        </v-card>
        <v-dialog width="800px" v-model="showHistory">
            <v-card>
                <v-toolbar color="purple" dark>
                    <v-toolbar-title>{{$t('lang.common.history')}}</v-toolbar-title>
                </v-toolbar>
                <v-data-table :items="historyItems" :headers="fields"
                              :total-items="totalRows"
                              :rows-per-page-items="rowsPerPageItems"
                              @update:pagination="onHistoryPaging">
                    <template slot="items" slot-scope="data">
                        <td>
                            {{data.index+1}}
                        </td>
                        <td>
                            {{data.item['name']}}
                        </td>
                        <td>
                            {{data.item['assignee']}}
                        </td>
                        <td>
                            {{displayDate(data.item['createTime'],"dd/MM/yyyy hh:mm")}}
                        </td>
                        <td>
                            {{displayDate(data.item['endTime'],"dd/MM/yyyy hh:mm")}}
                        </td>
                        <td>
                            <v-btn depressed outline icon fab dark color="primary" small
                                   @click="viewTaskData(data.item)">
                                <v-icon>list</v-icon>
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
                <div style="text-align: right">
                    <v-btn color="error" @click="onShowHistory(false)">
                        <v-icon dark left>arrow_back</v-icon>
                        {{$t('lang.common.close')}}
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import CTextbox from "../../../components/form/Textbox";
    import IDatepicker from "../../../components/form/DatePicker";
    import Validator from "../../../../public/js/validator";
    import Bpmn from "../../../../public/plugin/bpmn/bpmn";
    import IUpload from "../../../components/form/Upload";

    import axios from "axios/index";

    import FormGenerator from "../../../../public/plugin/form/form";
    import { router } from "../../../router";
    import BpmnModeler from 'bpmn-js/lib/Modeler';
    import style from 'bpmn-js/dist/assets/diagram-js.css'; // eslint-disable-line no-unused-vars
    import icons from 'bpmn-font/dist/css/bpmn-embedded.css'; // eslint-disable-line no-unused-vars
    import bpmncss from '../../../../public/plugin/bpmn/bpmn.css';
    import VueController from "../../../../public/js/controller"; // eslint-disable-line no-unused-vars
    //import path from "../../../router/paths";
    var BpmnViewer = require('bpmn-js').Viewer;

    const v = Validator();
    import path from "../../../router/paths";
    import ISelectbox from "../../../components/form/SelectBox";
    import IDataTable from "../../../components/form/DataTable";
    import IEntityTable from "../../../components/form/EntityForm";
    ////console.log("---v---");
    ////console.log(v);

    export default {
        name: 'task-view',
        components: {IUpload, IEntityTable, IDataTable, ISelectbox, CTextbox, IDatepicker, Validator},
        inheritAttrs: true,
        props: {
            formName: {
                type: String,
                default: 'lang.task.detail'
            },
            inputItems: {
                type: Array,
                default: () => []
            },
            readonly:{
                type:Boolean,
                default:false
            },
            createUrl: {
                type: String,
                default: ""
            },
            column: {
                type: String,
                default: "12"
            },
            rowsPerPageItems: {
                type: [Array, Number],
                default: () => [10, 20, 30, 40, 50]
            }
        },
        created() {
            VueController.push(this);
        },

        mounted() {
            Bpmn.initViewer("#canvas");
        },

        destroyed() {
            VueController.removeComponentByEl(this);
        },
        data: () => {
            return {
                values: {},
                startValue: {},
                show: false,
                currentPage: 1,
                lstModel: [],
                showHistory: false,
                historyItems: [],
                formProperties: {},
                formComponent: null,
                totalRows: 0,
                fields: [
                    {value: "index", text: "Index", sortable: false, width: "5%"},
                    {value: 'name', text: 'Activity Name', sortable: false, width: "30%"},
                    {value: 'assignnee', text: 'Assignnee', sortable: false, width: "30%"},
                    {
                        value: 'createDate',
                        text: 'Create Date',
                        sortable: false,
                        dateFormat: 'dd/MM/yyyy hh:mm',
                        width: "10%"
                    },
                    {value: 'endTime', text: 'End Time', sortable: false, dateFormat: 'dd/MM/yyyy hh:mm', width: "5%"},
                    {value: 'View', text: "View", sortable: false, compound: true, width: "10%"}
                ],
                pageSize: 5,
                tabs:""
            }
        },
        methods: {
            getComponentByName: function (componentName) {
                //
                // get from paths
                //
                for (let i = 0; i < path.length; i++) {
                    if (componentName == path[i].name) {
                        return path[i].component;
                    }
                }
                //
                // get from registered component
                //
                return null;
            },
            formViewLoad: function () {
                //console.log("form view load");
                //console.log(this.values);
                this.$refs.formView.initFromFlow(this.values["executionId"]);
            },

            save: function (xml) {
                this.values["flowConfig"] = xml;
                let validate = v.validate(this);
                if (validate) {
                    axios.post(process.env.VUE_APP_API_URL + this.createUrl, this.values).then(data => {
                        if (data.success) {
                            this.onCancel();
                        } else {
                            alert(data.description);
                        }
                    }, error => {
                        alert(error);
                    });
                } else {
                    alert("Validate fail");
                }
            },

            onShowHistory: function (showView) {
                this.showHistory = showView;
            },

            onProcess: function () {
                let form = VueController.getComponentByComponentName("form-input");
                form.showTaskData(this.values["formKey"], this.values["executionId"], this.values["id"]);
            },

            loadDiagramOfTask: function (id, taskDefinitionKey) {
                axios.post(process.env.VUE_APP_API_URL + '/task/getTaskModel?processDefinitionId=' + id).then(data => {
                    Bpmn.loadViewer(data, taskDefinitionKey);
                }, error => {
                });
            },

            loadTaskHistory: function () {
                axios.post(process.env.VUE_APP_API_URL + "/task/searchHistory?processInstanceId=" + this.values["processInstanceId"] + "&pageSize=" + this.pageSize + "&page=" + this.currentPage, this.values).then((data) => {
                    this.historyItems = data.items;
                    this.totalRows = data.count;
                    ////console.log(this.pagination);
                });
            },

            onHistoryPaging: function (page) {
                this.pagination = page.page;
                this.currentPage = page.page;
                this.pageSize = page.rowsPerPage;
                this.loadTaskHistory();
            },

            displayDate: function (data, format) {
                if (data == null) {
                    return "";
                }
                let dateDate = new Date(data);
                let month = dateDate.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let year = dateDate.getFullYear();
                let date = dateDate.getDate();
                if (date < 10) {
                    date = "0" + date;
                }
                let second = dateDate.getSeconds();
                let minute = dateDate.getMinutes();
                let hour = dateDate.getHours();
                let dateStr = format.replace("dd", date).replace("MM", month).replace("yyyy", year).replace("mm", minute).replace("hh", hour).replace("ss", second);
                return dateStr;
            },

            viewFromProcessInstanceId: function(processInstanceId){
                axios.post(process.env.VUE_APP_API_URL + "/task/workingTask?processInstanceId=" + processInstanceId).then(
                    data=>{
                        //console.log(data);
                        this.onView(data[0]);
                    }
                );

            },

            onView: function (value) {
                this.show = true;
                this.values = value;
                //console.log(value);
                this.loadDiagramOfTask(value["processDefinitionId"], value["taskDefinitionKey"]);
                this.loadTaskHistory();
                //
                // clear form
                //
                this.lstModel = [];
                this.formComponent = null;
                this.formProperties = {};
                this.startValue = {};
                //
                // load form config and data
                //
                axios.post(process.env.VUE_APP_API_URL + "/task/getStartFormKey?processDefinitionId=" + value["processDefinitionId"]).then(
                    data => {
                        ////console.log("form code:"+data);
                        if (data == null || data == undefined || data == "") {
                            //
                            // form is null
                            //
                        } else {
                            axios.post(process.env.VUE_APP_API_URL + "/form/getByCode?formCode=" + data).then(
                                form => {
                                    ////console.log(form.formConfig);
                                    FormGenerator.loadFormModel(FormGenerator.decodeHTML(form.formConfig), "formProcess");
                                    this.formProperties = FormGenerator.toFormProperties();
                                    ////console.log(this.formProperties);
                                    if (this.formProperties.component == undefined || this.formProperties.component == "") {
                                        this.lstModel = FormGenerator.modelToInputProperties();

                                        for (let i = 0; i < this.lstModel.length; i++) {
                                            if (this.lstModel[i].type == "Component") {
                                                ////console.log(this.lstModel[i].properties["componentName"]);
                                                this.lstModel[i].component = this.getComponentByName(this.lstModel[i].properties["componentName"]);
                                                try {
                                                    ////console.log(this.lstModel[i].properties["properties"]);
                                                    if (this.lstModel[i].properties["properties"] != undefined && this.lstModel[i].properties["properties"] != null && this.lstModel[i].properties["properties"] != "") {
                                                        let properties = JSON.parse(this.lstModel[i].properties["properties"]);
                                                        for (let key in properties) {
                                                            this.lstModel[i].properties[key] = properties[key];
                                                        }
                                                    }
                                                    ////console.log(this.lstModel[i]);
                                                } catch (e) {
                                                    //console.log(e);
                                                }
                                            }
                                        }

                                        axios.post(process.env.VUE_APP_API_URL + "/task/taskWorkingVariables?taskId=" + this.values["executionId"]).then(
                                            data => {
                                                //FormGenerator.loadInputData(data);
                                                ////console.log(data);
                                                this.startValue = data;
                                                for (let property in data) {
                                                    if (typeof data[property] == "object") {
                                                        for (let childp in data[property]) {
                                                            this.startValue[property + "." + childp] = data[property][childp];
                                                        }
                                                    }
                                                }
                                            },
                                            error => {

                                            }
                                        );
                                    } else {
                                        ////console.log("component form");
                                        this.lstModel = [];
                                        try {
                                            let componentName = this.formProperties.component;
                                            for (let i = 0; i < path.length; i++) {
                                                if (componentName == path[i].name) {
                                                    this.formComponent = path[i].component;
                                                    break;
                                                }
                                            }
                                        } catch (e) {
                                            //console.log(e);
                                        }
                                    }
                                },
                                error => {
                                }
                            );
                        }
                    },
                    error => {

                    }
                )

            },

            viewTaskData: function (item) {
                let form = VueController.getComponentByComponentName("form-input");
                form.viewTaskData(item["formKey"], item["executionId"], item["id"]);
            },

            onCancel: function () {
                this.show = false;
                let parent = VueController.getComponentByComponentName("task-management");
                if(parent != undefined && parent != null) {
                    parent.show = true;
                    parent.search();
                } else {
                    router.go(-1);
                }
                //let tl = VueController.getComponentByComponentName("task-management");

            }
        }
    }
</script>
